import { useMemo, useState, type ReactNode } from "react";
import { PageTitleOverrideContext } from "./pageTitleOverride";

export function PageTitleOverrideProvider({ children }: { children: ReactNode }) {
  const [override, setOverride] = useState<string | null>(null);
  const value = useMemo(
    () => ({ override, setOverride }),
    [override],
  );

  return (
    <PageTitleOverrideContext.Provider value={value}>
      {children}
    </PageTitleOverrideContext.Provider>
  );
}
